const baseUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://apex-scrap.onrender.com/api'
    : 'http://localhost:8000/api';

export default baseUrl;
